// 名称模板弹窗内部，每个tag对应的type值
export const NAME_TAG = {
    custom_text: 1,
    country: 2,
    language: 3,
    gender: 4,
    os: 5,
    bid_strategy: 8,
    st: 11,
    et: 12,
    age: 13,
};